import { stylePropsView } from "@tamagui/helpers";
import { createPropMapper } from "./createPropMapper";
import { mergeProps } from "./mergeProps";
function extendStaticConfig(config, parent) {
  if (!(parent && "staticConfig" in parent)) {
    return parseStaticConfig(config);
  }
  const parentStaticConfig = parent.staticConfig;
  const variants = mergeVariants(parentStaticConfig.variants, config.variants);
  const parentNames = [...parentStaticConfig.parentNames || []];
  if (parentStaticConfig.componentName) {
    parentNames.push(parentStaticConfig.componentName);
  }
  const deoptProps = config.deoptProps || /* @__PURE__ */ new Set();
  const defaultProps = mergeProps(parentStaticConfig.defaultProps, {
    ...config.defaultProps,
    ...config.defaultVariants
  })[0];
  return parseStaticConfig({
    ...parentStaticConfig,
    ...config,
    parentStaticConfig,
    deoptProps,
    variants,
    parentNames,
    validStyles: config.validStyles ? {
      ...parentStaticConfig.validStyles,
      ...config.validStyles
    } : parentStaticConfig.validStyles || stylePropsView,
    defaultProps
  });
}
const mergeVariants = (parentVariants, ourVariants) => {
  const variants = {
    ...parentVariants
  };
  if (ourVariants) {
    for (const key in ourVariants) {
      if (key in variants) {
        variants[key] = {
          ...variants[key],
          ...ourVariants[key]
        };
      } else {
        variants[key] = ourVariants[key];
      }
    }
  }
  return variants;
};
const parseStaticConfig = (config) => {
  const parsed = {
    defaultProps: {},
    ...config,
    parsed: true
  };
  return {
    ...parsed,
    propMapper: createPropMapper(parsed)
  };
};
export {
  extendStaticConfig,
  mergeVariants,
  parseStaticConfig
};
//# sourceMappingURL=extendStaticConfig.js.map
